import { SweepEvent } from './SweepEvent';
// right here means an intersection of a right cone side with an obstacle edge
export class RightIntersectionEvent extends SweepEvent {
    get EndVertex() {
        return this.endVertex;
    }
    set EndVertex(value) {
        this.endVertex = value;
    }
    constructor(coneRightSide, intersectionPoint, endVertex) {
        super();
        this.coneRightSide = coneRightSide;
        this.intersectionPoint = intersectionPoint;
        this.endVertex = endVertex;
    }
    get Site() {
        return this.intersectionPoint;
    }
    toString() {
        return 'RightIntersectionEvent ' + this.intersectionPoint;
    }
}
//# sourceMappingURL=RightIntersectionEvent.js.map